import { includes, isEqual, mapValues, filter, flatten, map, isArray } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'inventory-listing/actions/listingUsedActions.js';

import MediaQuery from 'react-responsive';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import {
    ClickOut,
    ShiftDigitalService,
    MEDIA_QUERIES,
    AnalyticsService,
    TRACKING_TAGS as TAGS,
    ADOBE_TAGS,
    AdobeService,
    ADOBE_VARIANT_CONSTANTS,
} from '@sm360/widget-commons-general';

import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel.js';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import ListingFilterHead from 'inventory-listing/components/ListingFilters/Components/ListingFiltersHead/ListingFiltersHead.jsx';
import { getFilters } from 'inventory-listing/services/ListingUsedService/ListingUsedService.js';
import SearchBar from 'inventory-listing/components/SearchBar/SearchBar.jsx';
import ListingFilterBodyStyle from 'inventory-listing/components/ListingFilters/Components/ListingFiltersBodyStyle/ListingFiltersBodyStyle.jsx';
import ListingFilterBrand from 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/ListingFiltersBrand.jsx';
import ListingFilterCategory from 'inventory-listing/components/ListingFilters/Components/ListingFiltersCategory/ListingFiltersCategory.jsx';
import ListingFilterDriveTrain from 'inventory-listing/components/ListingFilters/Components/ListingFiltersDriveTrain/ListingFiltersDriveTrain.jsx';
import ListingFilterOdometer from 'inventory-listing/components/ListingFilters/Components/ListingFiltersOdometer/ListingFiltersOdometer.jsx';
import MetadataButtonContainer from 'inventory-listing/components/ListingFilters/Components/MetadataButtonContainer/MetadataButtonContainer.jsx';
import ListingFilterYears from 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYears.jsx';
import metadataCategoriesCriteriaNames from 'inventory-listing/constants/metadataCategoriesCriteriaNames.js';
import ListingFiltersPrice from 'inventory-listing/components/ListingFilters/Components/ListingFiltersPrice/ListingFiltersPrice.jsx';
import ListingFilterColors from 'inventory-listing/components/ListingFilters/Components/ListingFiltersColors/ListingFiltersColors.jsx';
import OrderBy from 'inventory-listing/components/OrderBy/OrderBy.jsx';
import listingFilters from 'inventory-listing/constants/listingFilters.js';

import 'inventory-listing/components/ListingFilters/ListingFilters.scss';

class ListingFilters extends React.Component {
    constructor(props) {
        super(props);

        this.applyNewCriteria = this.applyNewCriteria.bind(this);
        this.renderFilters = this.renderFilters.bind(this);

        this.trackedCriteria = mapValues(metadataCategoriesCriteriaNames, (metadata) => metadata.criteriaKey);

        this.state = {
            metadataCategories: props.metadataCategories,
            isSDFilterEventSent: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const { metadataCategories, vehicleCriteria } = nextProps;
        if (metadataCategories !== this.state.metadataCategories) {
            const updatedMetadataCategories = metadataCategories.map((metadataCategory) => {
                const criteriaKey = metadataCategoriesCriteriaNames[metadataCategory.name];
                if (criteriaKey && metadataCategory.metadatas) {
                    const metadatasUpdated = metadataCategory.metadatas.map((metadata) =>
                        metadata.set('isSelected', includes(vehicleCriteria[criteriaKey], metadata.code))
                    );
                    return {
                        ...metadataCategory,
                        metadatas: metadatasUpdated,
                    };
                }
                return metadataCategory;
            });

            this.props.actions.setMetadatas(updatedMetadataCategories);
            this.setState({ metadataCategories: updatedMetadataCategories });
        }
        /* Dispatch ShiftDigital update events only if
        * VehicleCriteria change and (on first page load - when the colanderSlug is null or colanderSlug is equal on page refresh)
        * This or logic applied to limit the multiple events dispatch on colanderSlug change, since changing colander slug refresh the page
        */
        if (
            !isEqual(this.props.vehicleCriteria, nextProps.vehicleCriteria) &&
            (this.props.vehicleCriteria.colanderSlug === null ||
                this.props.vehicleCriteria.colanderSlug === nextProps.vehicleCriteria.colanderSlug)
        ) {
            if (this.state.isSDFilterEventSent) {
                ShiftDigitalService.createPageViewEvent();
            }
            ShiftDigitalService.updateTypedSearchEvent(nextProps.vehicleCriteria);
            // Set the state to keep track if filter event already sent or not
            this.setState({ isSDFilterEventSent: true });
        }
    }

    applyNewCriteria(values, criteria, isSelecting) {
        const inventoryType = this.props.colanderGroupSlug === COLANDER_GROUPS.NEW ? 'New' : 'Used';

        if (this.props.hasAdobeTagging) {
            const filteredMetadatas = filter(values, (metadata) => {
                return metadata.isSelected;
            });
            const selectedLabel = flatten(
                map(filteredMetadatas, (metadata) => {
                    return metadata.label;
                })
            );
            const filterType = listingFilters[criteria];
            const selectedFilterValue = isArray(selectedLabel) && selectedLabel.toString();

            if (this.props.colanderGroupSlug === COLANDER_GROUPS.COMMERCIAL) {
                // This is used commercial inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.COMMERCIAL_SEARCH_RESULT_PAGE_FILTER_BY('Used', filterType, selectedFilterValue),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            } else if (
                this.props.colanderGroupSlug === COLANDER_GROUPS.NEW &&
                this.props.inventoryType === 'Commercial'
            ) {
                // This is new commercial inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.COMMERCIAL_SEARCH_RESULT_PAGE_FILTER_BY('New', filterType, selectedFilterValue),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            } else {
                // This is either new or used inventory
                AdobeService.eventTrigger(
                    ADOBE_TAGS.SEARCH_RESULT_PAGE_FILTER_BY(inventoryType, filterType, selectedFilterValue),
                    ADOBE_VARIANT_CONSTANTS.GLOBAL_ONCLICK
                );
            }
        }
        if (includes(this.trackedCriteria, criteria) && isSelecting) {
            AnalyticsService.ga4Trigger(TAGS.LAYER_NAVIGATION__FILTERS(WindowProxy.location().pathname, criteria));
        }
        this.props.updateVehicleCriteria(values, criteria);
    }

    renderFilters() {
        const { vehicleCriteria } = this.props;

        return (
            <div>
                <ListingFilterHead
                    onFilterClose={this.props.onFilterClose}
                    resetFilters={this.props.updateVehicleCriteria}
                    colanderGroupSlug={this.props.colanderGroupSlug}
                    colanderList={this.props.colanderList}
                    hasNewInventory={this.props.hasNewInventory}
                    hasUsedInventory={this.props.hasUsedInventory}
                />
                <MediaQuery maxWidth={MEDIA_QUERIES.TABLET.MAX}>
                    <OrderBy
                        allowSortByDefault={this.props.hasMakePriorityEnabled}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                        inventoryType={this.props.inventoryType}
                    />
                </MediaQuery>
                <SearchBar textQuery={vehicleCriteria?.textQuery} />
                <ListingFilterCategory
                    colanders={this.props.colanders}
                    updateVehicleCriteria={(values, criteria) => {
                        this.applyNewCriteria(values, criteria);
                        this.props.updateVehicleCriteria([], 'makeIds');
                        this.props.updateVehicleCriteria([], 'modelIds');
                    }}
                    selectedColander={vehicleCriteria?.colanderSlug}
                />
                <ListingFiltersPrice
                    prices={getFilters(this.state.metadataCategories, 'priceRangeAll')}
                    salePriceRange={vehicleCriteria?.salePriceRange}
                    updateVehicleCriteria={this.applyNewCriteria}
                />
                <ListingFilterBodyStyle
                    bodystyles={getFilters(this.state.metadataCategories, 'frameStyleId')}
                    updateVehicleCriteria={this.applyNewCriteria}
                />
                <ListingFilterBrand
                    makes={getFilters(this.state.metadataCategories, 'makeId')}
                    models={getFilters(this.state.metadataCategories, 'modelId')}
                    contextMake={this.props.listingContext?.make}
                    updateVehicleCriteria={this.applyNewCriteria}
                    vehicleCriteria={vehicleCriteria}
                />
                <ListingFilterYears
                    years={getFilters(this.state.metadataCategories, 'year')}
                    contextYear={this.props.listingContext?.year}
                    yearRange={vehicleCriteria?.yearRange}
                    updateVehicleCriteria={this.applyNewCriteria}
                />
                <MetadataButtonContainer
                    metadatas={getFilters(this.state.metadataCategories, 'transmissionId')}
                    updateVehicleCriteria={this.applyNewCriteria}
                    groupTitle={LocaleService.t('FILTERS.TRANSMISSION')}
                    filterName="transmissionTypes"
                />
                <MetadataButtonContainer
                    metadatas={getFilters(this.state.metadataCategories, 'fuelId')}
                    updateVehicleCriteria={this.applyNewCriteria}
                    groupTitle={LocaleService.t('FILTERS.FUEL_TYPE')}
                    filterName="fuelTypes"
                />
                <ListingFilterOdometer
                    isUsed={this.props.colanderGroupSlug === COLANDER_GROUPS.DEFAULT}
                    odometers={getFilters(this.state.metadataCategories, 'odometerRangeAll')}
                    odometerRange={vehicleCriteria?.odometerRange}
                    updateVehicleCriteria={this.applyNewCriteria}
                />
                <ListingFilterDriveTrain
                    driveTrains={getFilters(this.state.metadataCategories, 'driveTrainId')}
                    updateVehicleCriteria={this.applyNewCriteria}
                />
                <ListingFilterColors
                    colors={getFilters(this.state.metadataCategories, 'exteriorColorId')}
                    updateVehicleCriteria={this.applyNewCriteria}
                />
                <div className="apply-button-bloc">
                    <button className="apply-button sr-button-2 is-small" onClick={this.props.onFilterClose}>
                        {LocaleService.t('BUTTONS.APPLY')}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="listing-used-filters">
                <MediaQuery maxWidth={MEDIA_QUERIES.TABLET.MAX}>
                    <ClickOut onClickOut={this.props.onFilterClose}>{this.renderFilters()}</ClickOut>
                </MediaQuery>
                <MediaQuery minWidth={MEDIA_QUERIES.DESKTOP.MIN}>{this.renderFilters()}</MediaQuery>
            </div>
        );
    }
}

ListingFilters.propTypes = {
    onFilterClose: PropTypes.func.isRequired,
    metadataCategories: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            metadatas: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)).isRequired,
        })
    ).isRequired,
    updateVehicleCriteria: PropTypes.func.isRequired,
    colanders: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            slug: PropTypes.string,
        })
    ).isRequired,
    colanderList: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
        })
    ).isRequired,
    vehicleCriteria: PropTypes.instanceOf(VehicleCriteriaModel).isRequired,
    actions: PropTypes.shape({
        // eslint-disable-line react/no-unused-prop-types
        setMetadatas: PropTypes.func.isRequired,
    }).isRequired,
    vehicleCount: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
    colanderGroupSlug: PropTypes.string.isRequired,
    hasUsedInventory: PropTypes.bool.isRequired,
    hasNewInventory: PropTypes.bool.isRequired,
    hasMakePriorityEnabled: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
    inventoryType: PropTypes.string.isRequired,
};

ListingFilters.defaultProps = {
    hasAdobeTagging: false,
    inventoryType: '',
};

ListingFilters.displayName = 'ListingFilters';

function mapStateToProps({ listingUsed }) {
    const { vehicleCriteria, metadatas } = listingUsed;

    return {
        vehicleCriteria,
        metadataCategories: metadatas,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListingFilters);
